import React, { Component } from 'react';
import { Panel } from "react-bootstrap";

import Spinner from '@sm/components/Spinner';
import Table from "@sm/components/custom/Table";

import '@assets/css/apiData.css';
import ExpandAllIcon from '@assets/images/expand-all-icon.png';
import CollapseAllIcon from '@assets/images/collapse-all-icon.png';

import { DASHBOARD_DEPOSITS_PER_MIDS } from '@sm/actions/types';
const store =  require('@sm/reducers/index');

class DashBoardDepositsPerMidComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deposits: undefined,
      loading: true,
      socket: false,
      expandAll: false,

      columns: [{
        value: "merchantName",
        label: "Merchant",
        leftAligned: true,
        isNumber: false
      }, {
        value: "method",
        label: "Method",
        leftAligned: true,
        isNumber: false
      }, {
        value: "currency",
        label: "Currency",
        leftAligned: true,
        isNumber: false
      }, {
        value: "traffic",
        label: "Traffic",
        leftAligned: true,
        isNumber: false
      }, {
        value: "channel",
        label: "Provider",
        leftAligned: true,
        isNumber: true
      }, {
        value: "midId",
        label: "MID",
        isNumber: false,
        leftAligned: true,
      }, {
        value: "midName",
        label: "Tags",
        leftAligned: true,
        isNumber: false
      }, {
        value: "transactions",
        label: "Txns",
        rightAligned: true,
        isNumber: true
      }, {
        value: "pending",
        label: "Pending",
        rightAligned: true,
        isNumber: true
      }, {
        value: "rejected",
        label: "Rejected",
        rightAligned: true,
        isNumber: true
      }, {
        value: "failed",
        label: "Failed",
        rightAligned: true,
        isNumber: true
      }, {
        value: "reversed",
        label: "Reversed",
        rightAligned: true,
        isNumber: true
      }, {
        value: "successful",
        label: "Successful",
        rightAligned: true,
        isNumber: true
      }, {
        value: "successRate",
        label: "Success Rate",
        rightAligned: true,
        isNumber: true
      }],
      gatewayColumn: {
        value: "gateway",
        label: "Gateway",
        leftAligned: true,
        isNumber: false
      }
    };
  }

  subscribeFunction = null;

  componentDidMount(){
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({
          loading: true
        });
      }

      if (state.update === DASHBOARD_DEPOSITS_PER_MIDS && this.props.thisMonth && state.depositsPerMids.socket) {
        this.setState({ deposits: state.depositsPerMids, loading: false, socket: state.depositsPerMids.socket });
        return;
      }

      if (state.update === DASHBOARD_DEPOSITS_PER_MIDS && !state.depositsPerMids.socket) {
        this.setState({ deposits: state.depositsPerMids, loading: false, socket: state.depositsPerMids.socket });
      }
    });
  };

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  };

  getAggregatedInfo = ( obj, uniqueValue, sortBy, prop, isAverage, isCount ) => {
    let sum = 0;
    let count = 0;
    let allExceptRejectedTrx = 0;
    let allSuccessTrx = 0;
    const sahulatPspId = 105;

    for( const el in obj ) {
      if( obj.hasOwnProperty(el) && (obj[el][sortBy] === uniqueValue) ) {
        sum += parseFloat(obj[el][prop]);
        count++;
        allSuccessTrx += obj[el]["successful"];
        let all = obj[el]["attempts"];
        //Include Rejected Trxns in Success Rate for SahulatPay
        if (obj[el]["channelId"] !== sahulatPspId) {
          all -= obj[el]["rejected"];
        }
        allExceptRejectedTrx += all;
      }
    }
    if (isAverage) {
      if (!allExceptRejectedTrx) return 0;
      return (allSuccessTrx / allExceptRejectedTrx * 100).toFixed(0);
    }
    if (isCount) {
      return count;
    }
    return sum;
  };

  getChildNodes = (items, filterValue, sortBy) => {
    const copy = items.map(object => ({ ...object }));
    if (!copy) {
      return [];
    }
    return copy.filter(elem => elem[sortBy] === filterValue).map(item => {
      return Object.assign(item, {
        [sortBy]: "-",
        midId: item.midId,
        channel: sortBy === "channel" ? item.channel : item.channelId,
        transactions: item.attempts,
        successRate: item.successRate + "%"
      });
    });
  };

  getChildNodeProperty = (uniqueValue, fieldName, sortBy) => {
    const { deposits } = this.state;
    return deposits.find(deposit => deposit[sortBy] === uniqueValue)[fieldName];
  };

  getColumns = () => {
    const columns = [ ...this.state.columns ];
    const { gatewayColumn } = this.state;
    const { sortBy } = this.props;

    if (sortBy === "channel") {
      [columns[0], columns[1], columns[2], columns[3], columns[4]] = [columns[4], columns[0], columns[1], columns[2], columns[3]];
      columns[0].isNumber = false;
      return columns;
    }
    if (sortBy === "currency") {
      [columns[0], columns[1], columns[2], columns[3], columns[4]] = [columns[2], columns[0], columns[1], columns[4], columns[3]];
      return columns;
    }

    if (sortBy === "traffic") {
      [columns[0], columns[1], columns[2], columns[3]] = [columns[3], columns[0], columns[1], columns[2]];
      return columns;
    }
    if (sortBy === "gateway") {
      columns.unshift(gatewayColumn);
      return columns;
    }
    return columns;
  };

  tableData = () => {
    const { deposits}  = this.state;
    const { sortBy } = this.props;

    if (!deposits) {
      return [];
    }

    const transformed = [];
    const unique = [...new Set(deposits.map(item => item[sortBy]))];

    for (let i = 0; i < unique.length; i++) {
      const mids = this.getAggregatedInfo(deposits, unique[i], sortBy, "midName", false, true);
      const midsCount = <span className="mids"> {`${mids} mid${mids !== 1 ? "s" : ""}`}</span>;
      transformed.push({
        ...( sortBy === "gateway" && { gateway: unique[i] } ),
        merchantName: sortBy === "merchantName" ? unique[i] : (mids > 1 ? "" : this.getChildNodeProperty(unique[i], "merchantName", sortBy)),
        channel: sortBy === "channel" ? unique[i] : (mids > 1 ? "" : this.getChildNodeProperty(unique[i], "channelId", sortBy)),
        currency: sortBy === "currency" ? unique[i] : (mids > 1 ? "" : this.getChildNodeProperty(unique[i], "currency", sortBy)),
        midName: mids > 1 ? "" : this.getChildNodeProperty(unique[i], "midName", sortBy),
        midId: mids > 1 ? midsCount : this.getChildNodeProperty(unique[i], "midId", sortBy),
        traffic: sortBy === "traffic" ? unique[i] : (mids > 1 ? "" : this.getChildNodeProperty(unique[i], "traffic", sortBy)),
        method: mids > 1 ? "" : this.getChildNodeProperty(unique[i], "method", sortBy),
        transactions: this.getAggregatedInfo(deposits, unique[i], sortBy, "attempts"),
        pending: this.getAggregatedInfo(deposits, unique[i], sortBy, "pending"),
        failed: this.getAggregatedInfo(deposits, unique[i], sortBy, "failed"),
        rejected: this.getAggregatedInfo(deposits, unique[i], sortBy, "rejected"),
        successful: this.getAggregatedInfo(deposits, unique[i], sortBy, "successful"),
        reversed: this.getAggregatedInfo(deposits, unique[i], sortBy, "reversed"),
        successRate: this.getAggregatedInfo(deposits, unique[i], sortBy, "successRate", true) + "%",
        childNodes: this.getChildNodes(deposits, unique[i], sortBy)
      });
    }
    if (sortBy === "gateway") {
      this.sortRows(transformed, 'gateway');
    }
    return transformed;
  };

  sortRows = (items, sortLabel) => {
    items.sort((elemA, elemB) => {

      if (elemA[sortLabel] === "None") return -1;
      if (elemB[sortLabel] === "None") return 1;

      return elemA[sortLabel].localeCompare(elemB[sortLabel]);
    });
  };

  onExpandCollapseClick = () => {
    this.setState({
      expandAll: !this.state.expandAll
    });
  };

  render() {
    const { deposits, expandAll, loading } = this.state;
    const { sortBy } = this.props;

    let sellsWrap = (
      <Panel>
        <Panel.Heading>
          <Panel.Title> PAYIN PERFORMANCE PER MID </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <Spinner smallContainer={ true } />
        </Panel.Body>
      </Panel>
    );

    if (!loading && deposits) {
      sellsWrap = (
        <Panel style={ { height: '100%' } }>
          <Panel.Heading>
            <Panel.Title> PAYIN PERFORMANCE PER MID </Panel.Title>
            <img
              src={ expandAll ? CollapseAllIcon : ExpandAllIcon }
              alt={ `${expandAll ? 'collapse' : 'expand'} all rows` }
              className="expand-collapse-icon"
              onClick={ () => this.onExpandCollapseClick() }
            />
          </Panel.Heading>
          <Panel.Body>
            <div className="panel-content table-content payout-requests payin-requests accordion-table">
              <Table
                columns={ this.getColumns() }
                headerColor="#223579"
                data={ this.tableData() }
                isStriped={ false }
                defaultSortBy={ sortBy !== "gateway" ? "transactions" : "merchantName" }
                sortDirection="DESC"
                expandAllRows={ expandAll }
                useArrow={ false }
                withSort={ true }
              />
            </div>
          </Panel.Body>
        </Panel>
      );
    }
    return sellsWrap;
  }

}

export default DashBoardDepositsPerMidComponent;